<script>
	import { createEventDispatcher } from "svelte";

	import SuperFund from "../models/SuperFund";

	export let disabled = false;
	export let superFunds = [];
	export let activeSuperFundIndex = 0;

	const dispatch = createEventDispatcher();

	const handleSelectFund = (i) => {
		dispatch("select-fund", { newIndex: i });
	};

	const handleAddFund = () => {
		dispatch("add-fund");
	};

	const handleRemoveFund = (i) => {
		dispatch("remove-fund", { index: i });
	};
</script>

<div>
	{#if !disabled}
		<button class="btn btn-primary btn-add-fund" type="button" on:click={() => handleAddFund()}>Add a Fund</button>
	{/if}

	{#each superFunds as fund, i (fund)}
		<div
			class="fund"
			class:active={activeSuperFundIndex === i}
			on:click={() => handleSelectFund(i)}
		>
			<div>
				{#if fund.FundNameOther}
					{fund.FundNameOther}
				{:else}
					{fund.FundNameLabel ? fund.FundNameLabel : `New Fund`}
				{/if}
				{#if superFunds.length > 1}
					<button type="button" class="btn btn-outline-primary btn-sm" on:click|stopPropagation={() => handleRemoveFund(i)}>
						Remove
					</button>
				{/if}
			</div>
		</div>
	{/each}
</div>

<style>
	.btn-add-fund {
		margin-bottom: 16px;
		width: 100%
	}

	.fund {
		margin-bottom: 10px;
	}

	.fund div {
		border: 1px solid #e4e6e8;
		border-radius: 6px;
		background-color: #ededed;

		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 4px 4px 4px 6px;
		margin: 0;
		min-height: 41px;
		font-size: 14px;
		cursor: pointer;
	}

	.fund.active div {
		border: 1px solid #e6692d;
		background-color: bisque;
	}

	.fund div button {
		min-width: auto;
	}
</style>
